// extracted by mini-css-extract-plugin
export default {"replies":"tweet-replies_replies__+NvLH","link":"tweet-replies_link__VHTjk","text":"tweet-replies_text__8ImRR"};